// import {XLSX} from 'xlsx' // bug
import * as XLSX from 'xlsx'
import Anto from '../data/anto.json'
import Character from '../data/character.json'
import {sunRise} from '../constants/hor-th'
export const getLrsFromSr = async(rsNo, rsDeg, rsLda, rqrMinsLoc, srMinsLoc, cb)=>{
    // let diffSr2Rqr = rqrMinsLoc >= srMinsLoc ? rqrMinsLoc - srMinsLoc : srMinsLoc - rqrMinsLoc  
    let diffSr2Rqr = rqrMinsLoc - srMinsLoc 
    let atRqrAnto = ((rsDeg * 60) + rsLda) * (Anto.data[rsNo].antomin/1800 )   // ex. = 127.6 (passedAnto)
    let futureAnto = Anto.data[rsNo].antomin - atRqrAnto  // ex. 40.39
    // console.log(`futureAnto => ${futureAnto}`)
    // console.log(`atRqrAnto => ${atRqrAnto}`)
    // console.log(`diffSr2Rqr => ${diffSr2Rqr}`)
    // console.log(`Anto.data[rsNo].antomin => ${Anto.data[rsNo].antomin}`)
    if (futureAnto >= diffSr2Rqr) {
      cb({
        rs : Anto.data[rsNo].rs,
        rsName : Anto.data[rsNo].id,
        antoMin :atRqrAnto,
        deg : atRqrAnto * 30 / Anto.data[rsNo].antomin
      })
    } else {
        let x = rsNo
        let currRqrAnto = diffSr2Rqr - futureAnto
        while (currRqrAnto > Anto.data[x+1].antomin) {
          currRqrAnto = currRqrAnto - Anto.data[x+1].antomin
        //   console.log(`anto x+1 : ${x+1} : ${Anto.data[x+1].id}=>  ${Anto.data[x+1].antomin}  min.`)               
        //   console.log(`currentRqrAnto =>  ${currRqrAnto}  min.`) 
          x++
        }
        let deg = currRqrAnto * 30 / Anto.data[x+1].antomin
        cb({
          rs : Anto.data[x+1].rs,
          rsName : Anto.data[x+1].id,
          antoMin :currRqrAnto.toFixed(3),
          deg : deg.toFixed(3)
        })
    }
  }
  
export const getRsCharacter =( rsStartAt , rsEndAt)=>{
    let chr = []
    for (let i = rsStartAt; i <= rsEndAt; i++) {
        chr.push({
            rsTH : Character.data[i].rsTH,
            character : Character.data[i].character
        })  
    }
    return chr
}

  const srMMDD = (MM , DD)=>{
    let selectedItem = []
    sunRise.filter((item)=>{
        if (item.month == MM && item.day == DD) {
            selectedItem.push(item)
        }
    })
    // console.log(`sr => ${JSON.stringify(selectedItem , null, 2)}`)
    return selectedItem
  }

  export const getSunRiseTime = (month , day )=>{   // month = "MM" , day = "DD"
    let dayNum = parseInt(day)
    let monthNum = parseInt(month)
    let monthNext = monthNum +1 < 10 ? `0${monthNum+1}`:`${monthNum+1}`
    let dd =  dayNum >=1 && dayNum <10 ? "01" : dayNum >=10 && day <20 ? "10" : dayNum >=20 ? "20" : null
    let srMins = 0
    // console.log(`monthNext => ${monthNext}`)
    const sr01 = srMMDD(month , "01")
    const sr10 = srMMDD(month , "10")
    const sr20 = srMMDD(month , "20")
    const sr01Next = srMMDD(monthNext , "01")
    // console.log(`sr01Next => ${JSON.stringify(sr01Next , null , 2)}`)
    let sr01Time = sr01[0].srHr*60 + sr01[0].srMin
    let sr10Time = sr10[0].srHr*60 + sr10[0].srMin  
    let sr20Time = sr20[0].srHr*60 + sr20[0].srMin
    let sr01NextTime = sr01Next[0].srHr*60 + sr01Next[0].srMin
    switch (dd) {
      case "01":
        srMins = sr01Time + ((sr10Time - sr01Time) / 10 * (dayNum-1))      
        break;
      case "10":
        srMins = sr10Time + ((sr20Time - sr10Time)/10 * (dayNum-10))
        break;
      case "20":
        let divider
        if (month == "01" || month == "03" || month == "05" || month == "07" || month == "08" || month == "10" || month == "12" ) {
          divider = 11   // 31 days per Month
        } else if( month == "02"){ 
          divider = 8  //  28 days per Month
        } else {
          divider = 10 // 30 days per Month
        }
        srMins = sr20Time + ((sr01NextTime - sr20Time) / divider * (dayNum-20))
        break;
      default:
        break;
    }
    console.log(`SunRise => month: ${month}, day: ${day} => ${srMins} minutes`)
    return srMins
  }

export const getRandomInt=(min, max)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export const frequencies = arr =>
arr.reduce((a, v) => {
  a[v] = (a[v] ?? 0) + 1;
  // let b = a[v]
  return a;
}, {});

export const getMax = arr =>
arr.reduce((prev , curr)=>{
    return curr > prev ? curr : prev;
})

export const getMin = arr =>
arr.reduce((prev , curr)=>{
    return curr < prev ? curr : prev;
})


export const getRangeXaxis = (min, max)=>{
    let arrX = []
    let minM = parseInt(min.slice(4,6))
    let maxM = parseInt(max.slice(4,6))
    if ((max-min) <= 12 ) {
        for (let i = minM; i <= maxM; i++){
            let MM = i <= 9 ? `0${i}` : `${i}`
            arrX.push(`${min.slice(0,4)}/${MM}`);    
        }  
    } else {  //  across year
        for (let i = minM; i <= 12; i++) {
            let MM = i <= 9 ? `0${i}` : `${i}`
           arrX.push(`${min.slice(0,4)}/${MM}`);
        }
        for (let i = 1; i <= maxM; i++) {
            let MM = i <= 9 ? `0${i}` : `${i}`
           arrX.push(`${max.slice(0,4)}/${MM}`);
        }
    }
    return arrX
}
export const getRangeXyyyyMM = (min, max)=>{
    let arrX = []
    let minM = parseInt(min.slice(4,6))
    let maxM = parseInt(max.slice(4,6))
    if ((max-min) <= 12 ) {
        for (let i = minM; i <= maxM; i++){
            let MM = i <= 9 ? `0${i}` : `${i}`
            arrX.push(`${min.slice(0,4)}${MM}`);    
        }  
    } else {  //  across year
        for (let i = minM; i <= 12; i++) {
            let MM = i <= 9 ? `0${i}` : `${i}`
           arrX.push(`${min.slice(0,4)}${MM}`);
        }
        for (let i = 1; i <= maxM; i++) {
            let MM = i <= 9 ? `0${i}` : `${i}`
           arrX.push(`${max.slice(0,4)}${MM}`);
        }
    }
    return arrX
}
export const exportXlsx = (items , name)=>{
    const dataWS = XLSX.utils.json_to_sheet(items)
const wb = XLSX.utils.book_new()
XLSX.utils.book_append_sheet(wb, dataWS)
XLSX.writeFile(wb, `${name}.xlsx`)
}


    